import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.owner}video/session/forcedisconnect`;

interface ForceDisconnectClientsCommandPayload {
  fileId: string;
}

export const forceDisconnectClientsCommand = async ({
  fileId,
}: ForceDisconnectClientsCommandPayload): Promise<
  BackResponse<never> | BackResponseFailure
> => {
  try {
    return await apiCall<BackResponse<never>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: { fileId },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
